import "../servise.scss"
import ServiseFooter from "./servise_footer";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const ServiseSkuter = () => {
   return (
    <div className="servise-page">
      <>
          <Helmet>
              <title>Pro Moto - serwis skuterow</title>
              <meta
              name="description"
              content=" Twój skuter ma być niezawodny w korkach i na weekendowych wypadach.
                W PRO MOTO serwisujemy maszyny od 125 cm³ do maxi-skuterów. Zajmujemy się wszystkim, 
                co mechaniczne, abyś mógł jeździć pewnie i bez niespodzianek."
              />
              <link rel="canonical" href="https://promotoserwis.pl/serwis-skuterow" />
          </Helmet>
      </>

      <section className="servise-hero">
        <div className="servise-hero__content">
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}>SERWIS SKUTERÓW</motion.h1>
          <motion.h2
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
             Twój skuter ma być niezawodny w korkach i na weekendowych wypadach.
             W PRO MOTO serwisujemy maszyny od 125 cm³ do maxi-skuterów. Zajmujemy się wszystkim, 
             co mechaniczne, abyś mógł jeździć pewnie i bez niespodzianek.
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              <strong>Przed wstawieniem na serwis prosimy o umycie pojazdu.</strong>
          </motion.p>
          <motion.h3
            initial={{ opacity: 0, y: 90 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              NIE SERWISUJEMY CHIŃSKICH SKUTERÓW WYPRODUKOWANYCH 
              PRZED 2020 ROKIEM ORAZ SKUTERÓW O POJEMNOŚCI DO 100 cm³
          </motion.h3>

          <button
            className="servise-scroll-btn"
            onClick={() =>
              document.querySelector(".servise-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>

      <section className="servise-extra">
        <div className="servise-extra__container">

          <div className="servise-block">
            <h3 className="servise-block_title">Zakres usług</h3>
          </div>

          <div className="servise-block">
            <h2>Silnik & układ CVT</h2>
            <ul>
              <li>Wymiana oleju, filtrów, świec zapłonowych</li>
              <li>Regulacja luzów zaworowych, remonty silników 2T/4T</li>
              <li>Serwis wariatora, rolek i sprzęgła odśrodkoweg</li>
              <li>Wymiana paska napędowego, kontrola napędu</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Układ hamulcowy</h2>
            <ul>
              <li>Wymiana klocków i tarcz hamulcowych</li>
              <li>Regeneracja zacisków, odpowietrzanie układu</li>
              <li>Płukanie i wymiana płynu hamulcowego</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Układ kierowniczy oraz zawieszenie</h2>
            <ul>
              <li>Wymiana łożysk główki ramy, drążków, tulei</li>
              <li>Regeneracja amortyzatorów, ustawianie zbieżności kół</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Wydech & tuning</h2>
            <ul>
              <li>Montaż i serwis układów wydechowych</li>
              <li>Instalacja zestawów tuningowych ≤ 50 cm³: cylindry, gaźniki, dysze</li>
              <li>Regulacje gaźnika/wtrysku po modyfikacjach</li>
            </ul>
          </div>
          <ServiseFooter/>

        </div>
      </section>
    </div>
  );
};


export default ServiseSkuter;
